import script from "./FloatingMessageIndicator.vue?vue&type=script&setup=true&lang=ts"
export * from "./FloatingMessageIndicator.vue?vue&type=script&setup=true&lang=ts"

import "./FloatingMessageIndicator.vue?vue&type=style&index=0&id=606617a2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-606617a2"]])

export default __exports__